export interface Occurrence {
  entry: string;
  index: number;
  length: number;
}

/**
 * Find entries that matches given RegExp in the provided source. Returns found
 * entry, its index in the source and its length.
 *
 * @param source {string}
 * @param regexp {RegExp}
 * @returns Found entries or empty array
 */
export const getOccurrences = (source: string, regexp: RegExp) => {
  const occurrences: Array<Occurrence> = [];
  let match;

  // It is crucial for algorithm for RegExp to have a global flag.
  const reg = new RegExp(regexp.source, `g${regexp.flags.replace('g', '')}`);

  do {
    match = reg.exec(source);

    if (match) {
      occurrences.push({
        entry: match[0],
        index: match.index,
        length: match[0].length,
      });
    }
  } while (match);

  return occurrences;
};
